<bzg-modal-header>
    <span class="bz-modal__title">{{'LDAP.TEST_RESULTS' | translate}}</span>
    <bzg-button-icon icon="icn-close" (click)="close()"></bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <div class="bmc-ldap-test-results">
        <div class="bmc-ldap-test-results__horizontal-container bz-space--stack-l">
            <div class="bmc-ldap-test-results__field">
                <h5 class="bz-font-weight--semibold">{{'LDAP.URL' | translate}}</h5>
                <div>{{ldapEnvironment.url}}</div>
            </div>
            <div class="bmc-ldap-test-results__field">
                <h5 class="bz-font-weight--semibold">{{'LDAP.FILTER' | translate}}</h5>
                <div>{{ldapEnvironment.filter}}</div>
            </div>
        </div>
        <h5 class="bz-font-weight--semibold bz-space--stack-m">{{'LDAP.LDAP_VALUES' | translate}}</h5>
        <div class="bmc-ldap-test-results__table bz-table--responsive">
            <table class="bz-table">
                <thead>
                    <tr>
                        <th class="bz-table__cell bz-table__cell--sortable" *ngFor="let col of columns">
                        <div class="bz-table__col-title" *ngIf="col.visible">
                            <span class="bz-space--inline-xs">{{ col.value | translate}}</span>
                            <div class="bz-table__col-sort">
                                <bzg-icon [nameIcon]="'icon-arrow-down-table'" (click)="sortByColumn(col.key, 1)"
                                    *ngIf="sortColumnName === '' || (sortColumnName === col.key && sortOrderType === 0) || sortColumnName !== col.key ">
                                </bzg-icon>
                                <bzg-icon [nameIcon]="'icon-arrow-up-table'" (click)="sortByColumn(col.key, 0)"
                                    *ngIf="sortColumnName === col.key && sortOrderType === 1">
                                </bzg-icon>
                            </div>
                        </div>
                        </th>
                    </tr>
                    </thead>
                <tbody>
                    <tr *ngFor="let userResult of paginatedTestResults">
                        <td class="bz-table__cell" *ngFor="let col of columns">
                            <div *ngIf="col.visible">
                                <div class="bz-table__cell-row" *ngIf="col.type === 'text'">{{ userResult[col.key] }}</div>
                            </div>
                        </td>
                        </tr>
                </tbody>
            </table>
        </div>
    </div>
</bzg-modal-content>
<bzg-modal-footer class="bmc-ldap-test-results__footer">
    <bzg-button-primary (click)="close()">{{ 'GLOBAL.CLOSE' | translate}}</bzg-button-primary>
</bzg-modal-footer>
